export default __webpack_public_path__ + "static/media/management.97df3747.webp";